'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PlaylistsItem = require('containers/Playlists/components/PlaylistsItem/PlaylistsItem');

var _PlaylistsItem2 = _interopRequireDefault(_PlaylistsItem);

var _AlbumsItemsGroupWrapper = require('../AlbumsItemsGroupWrapper/AlbumsItemsGroupWrapper');

var _AlbumsItemsGroupWrapper2 = _interopRequireDefault(_AlbumsItemsGroupWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlbumsItemsGroup = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(AlbumsItemsGroup, _PureComponent);

  function AlbumsItemsGroup() {
    (0, _classCallCheck3.default)(this, AlbumsItemsGroup);
    return (0, _possibleConstructorReturn3.default)(this, (AlbumsItemsGroup.__proto__ || (0, _getPrototypeOf2.default)(AlbumsItemsGroup)).apply(this, arguments));
  }

  (0, _createClass3.default)(AlbumsItemsGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          albumsGroup = _props.albumsGroup,
          showTitles = _props.showTitles,
          tracks = _props.tracks;


      return _react2.default.createElement(
        _AlbumsItemsGroupWrapper2.default,
        { showTitles: showTitles, title: albumsGroup.title },
        albumsGroup.data.map(function (album) {
          return _react2.default.createElement(_PlaylistsItem2.default, {
            key: album.project_id + '_' + album.recipient_id,
            album: album,
            tracks: tracks,
            coloredInfo: !showTitles
          });
        })
      );
    }
  }]);
  return AlbumsItemsGroup;
}(_react.PureComponent), _class.propTypes = {
  albumsGroup: _propTypes2.default.object,
  showTitles: _propTypes2.default.bool,
  tracks: _propTypes2.default.object
}, _class.defaultProps = {
  albumsGroup: { data: [] },
  tracks: {}
}, _temp);
exports.default = AlbumsItemsGroup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AlbumsItems/AlbumsItemsGroup/AlbumsItemsGroup.js
// module id = 1948
// module chunks = 1